// extracted by mini-css-extract-plugin
export default {"header":"ComedieDuLivreHeader_header__P+694","image":"ComedieDuLivreHeader_image__Njfb+"};